var render = function render(){var _vm=this,_c=_vm._self._c;return _c('portal',{attrs:{"target-el":"#fp-alert","target-class":"f-bs4"}},[(_vm.is.before('2025/6/18'))?_c('dorlotons'):_vm._e(),_vm._v(" "),_c('info')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }